import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { initGA } from "@/lib/ga";

const CompanyContext = createContext({ company: null });

export const useCompany = () => useContext(CompanyContext);

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState(null);

  useEffect(() => {
    api.get("/company").then((r) => {
      setCompany(r.data);
      if (r.data?.ga4_measurement_id) initGA(r.data.ga4_measurement_id);
    }).catch(() => {});
  }, []);

  return (
    <CompanyContext.Provider value={{ company: company || {} }}>
      {children}
    </CompanyContext.Provider>
  );
}
